<script>
export default {
  data: ()=>({
    label: undefined
  }),
  mounted(){
    if (this.$el.classList.contains('formlabel'))
      this.label = this.$el
    else
      this.label = this.$el.querySelector('.formlabel')
  },
  watch:{
    value(val){
      if (!this.label) return
      if (val)
        this.label.classList.add('filled')
      else
        this.label.classList.remove('filled')
    } 
  }
}
</script>

<style lang="sass">
.formfield
  border: none
  outline: none
  background: none
  display: block
  width: 100%
  text-align: left
  font-size: 16px
  line-height: 26px
  color: colors.$brown
  padding: 1px 0 0
  &_pointer
    cursor: pointer
  &::placeholder
    color: colors.$dim
  &[disabled]
    pointer-events: none
  &_witharrow
    display: flex
    justify-content: space-between
    align-items: center
    svg
      flex-shrink: 0
      margin: -10px 1px 10px 15px
      cursor: pointer
      &:first-child
        margin-left: auto
  &_select
    position: relative
    z-index: 1
    &::before
      content: ''
      position: absolute
      width: 100%
      height: 15px
      top: -15px
    svg
      pointer-events: none
</style>